// Import dependencies
import React from "react";

// Import styles
import "./ProjectsCard.css";

const Projects = (props) => {
  // Project information
  const { title, image, description, deploy, deployIcon, github, githubIcon } =
    props.project;

  return (
    <>
      <div class="card mt-2 relative top-1/2 left-1/2 bg-white_txt py-8 px-4">
        {/* Project Image */}
        <div class="image w-full h-full overflow-hidden">
          <img src={image} alt={`Imagen ${title}`} />

          <h5 className="font-bold font-Poppins text-md mt-2 capitalize">
            {title}
          </h5>
        </div>

        {/* Project Details */}
        <div class="details absolute top-0 left-0 w-full h-full bg-dark_primary">
          <div class="center py-4 px-4 text-center bg-white_txt absolute top-1/2">
            <h5 className="font-bold font-Poppins text-sm capitalize">
              {title}
            </h5>

            <p className="text-sm text-justify text-dark_secondary font-Poppins">
              {description}
            </p>

            {/* Technologies */}
            <ul>
              {props.project.technologies.map((tecno, index) => (
                <li key={index}>
                  <img
                    src={tecno.icon}
                    alt={tecno.name}
                    className="w-8 h-8"
                    title={tecno.name}
                  />
                </li>
              ))}
            </ul>

            {/* Deploy & Repository */}
            <ul>
              <li className="flex items-center gap-1">
                <a href={deploy} target="_blank" rel="noreferrer">
                  <img src={deployIcon} alt="Deploy" />
                </a>

                <span className="font-bold">Demo</span>
              </li>

              <li className="flex items-center gap-1">
                <a href={github} target="_blank" rel="noreferrer">
                  <img src={githubIcon} alt="Repositorio" />
                </a>

                <span className="font-bold">Repositorio</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Projects;
